import { Component, OnInit } from '@angular/core';
import { TypeSanctionService } from 'src/app/_services/RH-service/sanction/type-sanction.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifService } from 'src/app/_services/notif.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-type-sanction-add',
  templateUrl: './type-sanction-add.component.html',
  styleUrls: ['./type-sanction-add.component.scss']
})
export class TypeSanctionAddComponent implements OnInit {

  TypeSanctionForm: FormGroup;
  isLoading = false;
  isError = false;
  isSuccess = false;
  isSubmitted = false;
  isMaterial: boolean = false;

  constructor(
    private TypeSanctionService: TypeSanctionService,
    private notifService: NotifService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private router: Router,
    private ref: MatDialog
  ) {}

  ngOnInit() {this.isMaterial = '/type-sanction/add' != location.pathname;
    this.isMaterial = '/type-sanction/add' != location.pathname;
    this.TypeSanctionForm = this.formBuilder.group({
      name:['',[Validators.required]],
      description:[''],
    });

  }

  get form() {
    return this.TypeSanctionForm.controls;
  }

  onSubmit() {
    console.log('on submit');
    this.isSubmitted = true;
    this.isError = false;
    this.isSuccess = false;
    this.isLoading = false;

    if (this.TypeSanctionForm.invalid) {
      this.translate.get('TypeSanction.SubmitError')
        .subscribe(val => this.notifService.danger(val));
      return;
    }

    this.isLoading = true;
    const formData = new FormData();
    formData.append('name', ''+this.form.name.value);
    formData.append('description', ''+this.form.description.value);

      console.log(formData);
      this.TypeSanctionService.post(formData)
      .then(resp => {
        this.translate.get('TypeSanction.SubmitSuccess')
        .subscribe(val => this.notifService.success(val));
        this.isSubmitted = false;
        this.TypeSanctionForm.reset();
      })
      .catch(err => {
        console.log(err)
        this.translate.get('TypeSanction.SubmitErrorTypeSanction')
        .subscribe(val => this.notifService.danger(val));
      })
      .finally(() => this.isLoading = false);
  }


  close() {
    this.ref.closeAll();
    // location.reload();
  }

}
